import { render, staticRenderFns } from "./DialogGuaranteeInjury.vue?vue&type=template&id=624d6196&"
import script from "./DialogGuaranteeInjury.vue?vue&type=script&lang=js&"
export * from "./DialogGuaranteeInjury.vue?vue&type=script&lang=js&"
import style0 from "./DialogGuaranteeInjury.vue?vue&type=style&index=0&id=624d6196&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports